import { render, staticRenderFns } from "./cover_cc_fee.schema.vue?vue&type=template&id=3b80806c&"
import script from "./cover_cc_fee.schema.vue?vue&type=script&lang=js&"
export * from "./cover_cc_fee.schema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports